import { defineStore } from "pinia";
import { ref } from "vue";

export const useDebugStore = defineStore("debug-store", () => {
	let debugMode = ref<boolean>(false);
	let altKeyHeld = ref<boolean>(false);

	function toggleDebugMode(): void {
		debugMode.value = !debugMode.value;
	}

	function setAltKeyHeld(value: boolean): void {
		altKeyHeld.value = value;
	}

	return {
		debugMode,
		altKeyHeld,
		toggleDebugMode,
		setAltKeyHeld,
	};
});
